'use client';

import NoCollectList from '@fe-news/components/organisms/NewsCollectContent/NoCollectList';
import LoginModal from '@fe-news/components/molecules/LoginModal';
import NewsCollectContentLazy from '@fe-news/components/organisms/NewsCollectContent/NewsCollectContentLazy';
import { useNewsCollect } from '@fe-news/context/news-collect-provider';

const NewsCollect = ({ children }: { children: React.ReactNode }) => {
  const { isCloseLoginModal, onClickLoginModalClose, isLoggedIn } = useNewsCollect();

  return (
    <>
      <LoginModal isModalClosed={isCloseLoginModal} onClickModalClose={onClickLoginModalClose} />
      {!isLoggedIn && <NoCollectList>{children}</NoCollectList>}
      {isLoggedIn && <NewsCollectContentLazy>{children}</NewsCollectContentLazy>}
    </>
  );
};

export default NewsCollect;
